<template>
  <div class="unfinish-outer">
    <van-sticky>
      <!-- <div class="top-outer">
        <van-search
          v-model="valueSearch"
          placeholder="请输入搜索关键词"
          background="#FFF"
          shape="round"
          class="search"
          @search="onSearch"
        />
        <span class="more-submit">批量审批</span>
      </div> -->

      <div class="top-outer2" v-show="isPublic">
        <div class="left">
          <span class="type-css">审批类型：</span>
          <van-dropdown-menu active-color="#006C50" class="drop">
            <van-dropdown-item v-model="valueType" :options="option1" @change="changeSubmitType" />
          </van-dropdown-menu>
          <el-button type="primary" size="mini" @click="flag = !flag; idList = []; isGetAll = false" style="width: 80px;" v-show="a">{{ !flag ?
            '批量处理' : '取消'}}</el-button>
        </div>
        <div class="right">
          <el-input size="mini" placeholder="搜索发起人或审批单号" v-model="params.keyword" @input="onSearch" />
          <span  v-show="flag">
            <el-checkbox style="margin-top: 1rem;" label="全选" v-model="isGetAll" @change="getAll" /> 全选
          </span>
        </div>
        <!-- <div class="right" v-if="false">
          <span class="item-btn" @click="handler('refuse')">批量拒绝</span>
          <span class="item-btn" @click="handler('agree')">批量同意</span>
        </div> -->
      </div>
    </van-sticky>

    <van-calendar v-model="showDate" @confirm="onConfirm" :max-date="maxDate" :min-date="minDate" color="#006C50" />
    <div class="mlist">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list class="van-clearfix" v-model="loading" :finished="finished" :error.sync="error"
          error-text="请求失败，点击重新加载" finished-text="" @load="onLoad">
          <!-- <van-button type="primary" @click="checkAll">全选</van-button>
          <van-button type="info" @click="toggleAll">反选</van-button> -->

          <!-- <van-checkbox-group v-model="result" ref="checkboxGroup"> -->
          <template v-if="dataList && dataList.length > 0">
            <div class="groups-outer" :key="index" v-for="(item, index) in dataList">
              <div>
                <el-checkbox-group v-show="flag" v-model="idList" :max="5">
                  <el-checkbox :key="item.instanceId" :label="item.instanceId"
                    :disabled="item.hasSign || item.hasRequired" />
                </el-checkbox-group>
              </div>
              <div class="item" :key="index" @click="flag ? toggleCheckbox(item) : showProcess(item)">
                <!-- <div class="status">待处理</div> -->
                <div class="line">
                  <div class="t-title">审批类型：</div>
                  <div class="t-txt">{{ item.processDefName }}</div>
                </div>
                <div class="line">
                  <div class="t-title">申请单号：</div>
                  <div class="t-txt">{{ item.instanceId }}</div>
                </div>
                <div class="line">
                  <div class="t-title">提交时间：</div>
                  <div class="t-txt">{{ item.createTime }}</div>
                </div>
                <div class="line">
                  <div class="t-title">申请部门：</div>
                  <div class="t-txt">{{ item.ownerDeptName }}</div>
                </div>
                <div class="line">
                  <div class="t-title">申请人：</div>
                  <div class="t-txt">{{ item.owner == null ? "" : item.owner.name }}</div>
                </div>
                <div class="line">
                  <div class="t-title">摘要信息：</div>
                  <div class="t-txt">
                    <form-abstracts :value="item.formAbstracts" />
                  </div>
                </div>
                <div class="line">
                  <div class="t-title">当前节点：</div>
                  <div class="t-txt">{{ item.taskName }}</div>
                </div>
                <div class="line">
                  <div class="t-title">任务到达时间：</div>
                  <div class="t-txt">{{ item.taskCreateTime }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="no-data">
              <img src="../../../assets/image/n5.png" class="img" />
              <!-- <img src="../../assets/image/logo.png"/> -->
              <!-- <img src="../../assets/image/n5.png" class="img" /> -->
              <span class="txt">暂无内容</span>
            </div>
          </template>
          <div v-if="idList.length > 0" class="btn">
            <el-button-group>
              <el-button type="danger" @click="showDialog('refuse')" size="mini" style="margin: 10px;">拒绝</el-button>
              <el-button type="primary" @click="showDialog('agree')" size="mini" style="margin: 10px;">同意</el-button>
            </el-button-group>
          </div>
          <!-- </van-checkbox-group> -->
        </van-list>
      </van-pull-refresh>
    </div>

    <el-drawer size="100%" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :node-id="selectInstance.nodeId" :instance-id="selectInstance.instanceId"
        @handler-after="handlerAfter"></instance-preview>
    </el-drawer>

    <w-dialog v-model="actionVisible" :ok-loading="actionLoading" width="90vw" :title="actionDesc.title"
      :okText="actionType === 'refuse' ? '拒 绝' : '同 意'" @ok="doAction">
      <process-action ref="action" @success="handlerOk" @fail="actionLoading = false" :form-data="formData"
        v-if="actionVisible" :action="actionType" :action-desc="actionDesc" show-sign @loadings="handleLoading"/>
    </w-dialog>
  </div>
</template>

<script>
import taskApi from "@/api/processTask";
import InstancePreview from "../approval/ProcessInstancePreview";
import FormAbstracts from "@/views/workspace/oa/FormAbstracts.vue";
import ProcessAction from "../approval/ProcessAction";
import uniWebview from "@dcloudio/uni-webview-js";
import moment from "moment";
import { Toast } from "vant";
import _ from 'lodash';
import {getUserCrossTodoList} from '@/api/cross'
import {getApproval} from '@/api/modelGroup'

export default {
  name: "UnFinished",
  components: { InstancePreview, FormAbstracts, ProcessAction },
  data() {
    return {
      a: false,
      total: 0,
      result: [],
      showDate: false,
      isGetAll: false,
      error: false,
      flag: false,
      isPublic: true,
      optionInputInfo: "",
      actionLoading: false,
      maxDate: moment().toDate(),
      minDate: moment().subtract(30, "days").toDate(),
      // maxDate: new Date(),
      //minDate:(new Date(new Date() - 3600 * 1000 * 24 * 29)),
      valueSearch: "",
      option1: [],
      value1: 0,
      valueType: 0,
      instanceData: {},
      // list: [1, 1, 2, 3, 4, 5, 6, 6, 7],
      loading: false,
      finished: false,
      actionVisible: false,
      refreshing: false,
      params: {
        pageSize: 10,
        pageNo: 0,
        //  code: "",
      },
      date: moment().format("YYYY-MM-DD"),
      selectInstance: null,
      selectInstance2: null,
      processVisible: false,
      processVisible2: false,
      actionType: 'agree',
      formList: [],
      dataList: [],
      chekedList: [],
      idList: [],
      actionData: {},
      imageList: []
    };
  },
  computed: {
    // approveListCom(){
    //   return JSON.parse(localStorage.getItem("approveList"))||[]
    // }
    actionDesc() {
      switch (this.actionType) {
        case "agree":
          return {
            tip: "审批意见",
            title: "同意审批",
          };
        case "refuse":
          return { tip: "驳回意见", title: "拒绝审批" };
      }
    },
  },
  created() {
    //this.sendTitle()
    //清空购物车
    localStorage.removeItem("approveList");
    this.getApproval()
  },
  mounted() {
    // this.sendTitle()
    //console.log("mmmmmmmmm")
    // //清空购物车
    //       localStorage.removeItem("approveList")
    //chekedList
    this.getTodoList();
  },
  methods: {
    getApproval() {
      getApproval().then(res => {
        this.a = res.data == 1 ? true : res.data == 0 ? false : null
      })
    },
    sendTitle() {
      uniWebview.postMessage({
        data: { name: "协同-待办事宜", flag: "title" },
      });
    },
    //勾选了一个
    changeCheckItem(item, index) {
      let temCarList = JSON.parse(localStorage.getItem("approveList")) || [];

      //操作购物车
      let indexFind = temCarList.findIndex(
        (v) => v.instanceId == item.instanceId
      );
      if (indexFind > -1) {
        //购物车里有
        //删除
        temCarList.splice(indexFind, 1);
        //当前数据列表更新一下
        this.dataList[index].checkFlag = "0";
      } else {
        //购物车里没有,加进去
        temCarList.push({
          ...item,
          checkFlag: "1",
        });
        //当前数据列表更新一下
        this.dataList[index].checkFlag = "1";
      }
      // 同步到本地存储(数据缓存)
      localStorage.setItem("approveList", JSON.stringify(temCarList));
    },
    toggleCheckbox(item) {
      if (!item.hasSign && !item.hasRequired) {
        // 获取当前复选框是否已选中
        const index = this.idList.findIndex(i => i === item.instanceId);

        if (index > -1) {
          // 已存在，移除
          this.idList.splice(index, 1);
        } else {
          if (this.idList.length < 50) {
            // 不存在，添加
            this.idList.push(item.instanceId);
          } else {
            this.$message.error("最多只能选择50个")
          }
        }
      }
    },
    showDialog(type) {
      this.actionType = type;
      this.actionVisible = true;
    },
    doAction() {
      const instanceList = this.dataList.filter(item => this.idList.includes(item.instanceId))
      this.actionLoading = true
      let params = []
      for (let i = 0; i < instanceList.length; i++) {
        params.push({
          instanceId: instanceList[i].instanceId,
          taskId: instanceList[i].taskId,
          comment: {
            text: this.$refs.action.actionData.comment.text,
            attachments: this.$refs.action.imageList.concat(this.$refs.action.fileList)
          },
          action: this.actionType,
          formData: null, // 已经判断如果有表单项需要在此节点填写的无法选中批量审批
          signature: null,
          updateSign: null,
          targetNode: null,
          targetUser: null,
        })
      }
      taskApi.approvalTaskList(params).then(rsp => {
        this.actionLoading = false
        this.actionVisible = false
        this.idList = []
        this.flag = false
        this.getTodoList()
        this.$message.success('处理任务成功')
      }).catch(err => {
        console.log(err)
        this.$message.error('处理任务失败')
      })
    },
    popSubmit() {
      ///result
      //dataList
      let checkedList = this.dataList.filter((item) => {
        return this.result.includes(item.instanceId);
      });
    },
    handler(action) {
      // this.actionType = action;
      // this.actionVisible = true;
      // processVisible2
      let temCarList = JSON.parse(localStorage.getItem("approveList")) || [];
      let that = this;
      if (temCarList.length > 0) {
        // let checkedObjectOne = this.dataList.find((item) => {
        //   return this.result.includes(item.instanceId);
        // });
        // console.log("````" + checkedObjectOne);
        this.selectInstance2 = temCarList[0];
        this.processVisible2 = true;
        setTimeout(function () {
          that.$refs.childs.handler(action);

          // 需要执行的代码
        }, 500); // 定时时间
      } else {
        Toast.fail("还没有选中的审批");
      }
    },
    changeSubmitType() {
      this.dataList = [];

      this.params.pageNo = 1;
      this.getTodoList();
    },
    onSearch(value) {
      this.params.pageNo = 1
      this.requestData();
    },
    selectTime() {
      this.showDate = true;
    },
    // formatDate(date) {
    //   return `${date.getMonth() + 1}/${date.getDate()}`;
    // },
    onConfirm(date) {
      this.showDate = false;
      this.date = moment(date).format("YYYY-MM-DD");
    },
    checkAll() {
      this.$refs.checkboxGroup.toggleAll(true);
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll();
    },
    getAll(e) {
      if (!e) {
        this.idList = [];
      } else {
        // 过滤掉 hasSign 或 hasRequired 的项
        const filteredDataList = this.dataList.filter(item => !(item.hasSign || item.hasRequired));

        if (this.dataList.length < 51 && filteredDataList.length < 51) {
          this.idList = filteredDataList.map(item => item.instanceId);
        } else {
          const list = this.$deepCopy(filteredDataList);
          this.idList = list.splice(0, 50).map(item => item.instanceId);
          this.$message.error("最多只能选择50个");
        }
      }
    },
    getAssignedList() {
      //alert("1");
      taskApi
        .getAssignedList(this.$route.query.instanceId)
        .then((rsp) => {
          this.loading = false;
          this.isPublic = false;
          this.total = rsp.data.total;
          this.dataList = [...this.dataList, ...rsp.data.records];
          let temCarList =
            JSON.parse(localStorage.getItem("approveList")) || [];
          let mapList = this.dataList.map((item) => {
            let indexFind = temCarList.findIndex(
              (v) => v.instanceId == item.instanceId
            );

            if (indexFind < 0) {
              return {
                ...item,
                checkFlag: "0",
              };
            } else {
              return {
                ...item,
                checkFlag: "1",
              };
            }
          });
          this.dataList = [...mapList];
          if (this.dataList.length < this.total) {
          } else {
            this.finished = true;
          }
        })
        .catch((e) => {
          this.error = true;
        });
    },
    getTodoList() {
      if (this.option1.length > 0) {
        this.requestData();
      } else {
        taskApi
          .mySubmitTypeList({})
          .then((rsp) => {
            //console.log(rsp.data)
            //  { text: "全部", value: 0 },
            let typeList = rsp.data.filter(
              (item) => item.id != 1 && item.id != 2
            );
            let ArrFilterDatas = [];
            typeList.map((item) => {
              ArrFilterDatas = [...ArrFilterDatas, ...item.items];
            });
            //  console.log("```````" + JSON.stringify(ArrFilterDatas));
            let temArr = [
              {
                formName: "全部",
                formId: 0,
              },
              ...ArrFilterDatas,
            ];
            this.option1 = temArr.map((item, index) => {
              return {
                text: item.formName,
                value: item.formId,
              };
            });

            this.requestData();
          })
          .catch((e) => {
            // this.error = true;
            //this.loading = false;
          });
      }
    },
    requestData() {
      this.sendTitle();
      this.loading = true;
      // console.log("请求数据 " + this.valueType);
      getUserCrossTodoList({
          ...this.params,
          //   formName: this.valueType > 0 ? this.option1[this.valueType].text : "", //审批类型
          code: this.valueType != 0 ? this.valueType : "", //审批类型
          isCross: 0
        })
        .then((rsp) => {
          console.log(rsp)
          // 判断是否是第一页，如果是，则清空列表
          if (this.params.pageNo === 1) {
            this.dataList = [];
          }
          this.loading = false;
          this.total = rsp.data.total;

          this.dataList = [...this.dataList, ...rsp.data.records];
          let temCarList =
            JSON.parse(localStorage.getItem("approveList")) || [];
          //购物车有数据需要判断，回显已经勾选的
          //  if (temCarList.length > 0) {
          let mapList = this.dataList.map((item) => {
            let indexFind = temCarList.findIndex(
              (v) => v.instanceId == item.instanceId
            );

            if (indexFind < 0) {
              return {
                ...item,
                checkFlag: "0",
              };
            } else {
              //有
              return {
                ...item,
                checkFlag: "1",
              };
            }
          });
          this.dataList = [...mapList];

          // }

          if (this.dataList.length < this.total) {
          } else {
            this.finished = true;
          }
          // if (this.dataList.length >= 40) {
          //   this.loading = false;
          //   this.finished = true;
          // }
        })
        .catch((e) => {
          this.error = true;
        });
    },
    handleLoading(e) {
      this.actionLoading = e
      this.$emit("loadings", e);
      this.$forceUpdate()
    },
    onLoad() {
      if (this.refreshing) {
        this.dataList = [];
        this.refreshing = false;
        this.params.pageNo = 1;
      } else {
        //this.dataList = [];
        //  加载下一页面的时候改下起始页数
        this.params.pageNo = this.params.pageNo + 1;
        if (this.error) {
          this.params.pageNo = 1;
        }
      }
      // 如果是外部报修表单，只查询指定的流程
      if (this.$route.query.openId && this.$route.query.instanceId) {
        this.getAssignedList();
      } else {
        this.getTodoList();
      }

      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.dataList = [];
      //     this.refreshing = false;
      //     this.params.pageNo=1
      //   }else{
      //     //加载下一页面的时候改下起始页数
      //    // this.params.pageNo=this.params.pageNo+1
      //   }

      //  this.getTodoList()
      // }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.params.pageNo = 1;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;

      this.onLoad();
    },
    showProcess(row) {
      //console.log(JSON.stringify(row))
      this.processVisible = true;
      this.selectInstance = row;
    },
    handlerAfter() {
      //alert("1");

      this.processVisible = false;
      // this.params.pageNo = 1;

      // this.dataList = [];

      // this.getTodoList();
      this.dataList = [];
      this.refreshing = true;
      // this.params.pageNo = 1;
      //this.getTodoList();
      this.onRefresh();
    },
    handlerAfter2() {
      this.processVisible2 = false;
      this.params.pageNo = 1;
      //this.result = [];
      this.dataList = [];
      this.getTodoList();
    },
  },
  // watch: {
  //   params: {
  //     deep: true,
  //     handler() {
  //       this.getTodoList();
  //     },
  //   },
  // },
};
</script>

<style scoped lang="less">
/deep/ .el-checkbox__label {
  display: none !important;
}

.unfinish-outer {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background-color: #fff;

  /deep/ .van-dropdown-menu {
    /* 添加  !important 是为了避免样式的优先级不如之前的*/
    width: 50% !important;
  }

  /deep/ .van-dropdown-menu__title {
    width: 12rem;
  }
  /deep/ .van-checkbox__icon {
    font-size: 2rem;
  }
  /deep/ .van-calendar__footer {
    .van-button {
      width: 100%;
    }
  }
  /deep/.van-dropdown-menu__bar {
    box-shadow: none !important;
    background-color: #fff;
  }
  /deep/ .el-drawer__header {
    font-size: 1.6rem !important;
    color: #333;
  }
  /deep/ .el-drawer__close-btn {
    font-size: 1.6rem !important;
    color: #333;
  }
  /deep/ .van-dropdown-menu__title {
    font-size: 1.3rem;
  }
  /deep/ .van-search {
    padding: 0;
    .van-icon {
      font-size: 1.5rem;
    }
  }
  /deep/ .van-cell {
    line-height: 2.3rem;
    font-size: 1.3rem;
  }
  /deep/ .van-dropdown-menu__bar {
    height: 3rem;
  }
  /deep/ .van-sticky--fixed {
    background-color: #fff;
  }
  .groups-outer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    .checkout-outer {
      padding-right: 1rem;
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
  }
  .popup-sku-con-outer {
    width: 90vw;
    padding: 1rem;
    .pop-title-con {
      margin: 1rem 0;
      font-size: #333;
      font-size: 1.4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .input-outer {
      margin: 1rem 0;
      font-size: 1.3rem;
    }
    .edit-input {
      margin: 1rem 0;
    }
    .option-btns {
      display: flex;
      justify-content: center;
      .van-button {
        width: 80%;
        background-color: #006c50;
        margin: 1rem 0;
        font-size: 1.5rem;
      }
    }
    /deep/ .el-textarea {
      font-size: 1.2rem;
    }
  }

  .top-outer {
    width: 100%;
    margin-top: 1rem;
    display: flex;
    padding: 0 2rem;
    background-color: #fff;
    align-items: center;
    justify-content: space-between;

    .search {
      width: 60vw;
    }
    .more-submit {
      padding: 1rem 1.5rem;
      background-color: #006c50;
      color: #fff;
      font-size: 1.3rem;
      border-radius: 2rem;
    }
  }
  .top-outer2 {
    margin-top: 1rem;
    // display: flex;
    background-color: #fff;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    font-size: 1.3rem;
    box-sizing: border-box;
    margin-bottom: 1rem;
    .left {
      flex: 1;
      display: flex;
      align-items: center;
      .type-css {
        padding-bottom: 0.18rem;
      }
    }
    .right {
      margin-top: 1rem;
    }
  }
  .mlist {
    width: 100%;
    padding: 2rem;

    flex: 1;
    /deep/ .van-checkbox-group {
      .van-checkbox__icon {
        margin-right: 1rem;
      }
      .van-checkbox__label {
        flex: 1;
      }
    }
    .item {
      padding: 0.8rem;
      flex: 1;

      background-color: #fff;
      border-radius: 1.5rem;
      box-sizing: border-box;
      box-shadow: 0px 0.2rem 1rem rgba(1, 12, 23, 0.06);

      margin-bottom: 1.5rem;
      position: relative;
      .line {
        display: flex;
        align-items: flex-start;
        padding: 0.3rem 0;
        .t-title {
          width: 12rem;
          font-size: 1.3rem;
          color: #333;
        }
        .t-txt {
          font-size: 1.3rem;
          color: #666;
        }
      }
      .status {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 1.3rem;
        background: #eef5f3;
        color: #006c50;
        line-height: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
        padding: 0 0.8rem;
        box-sizing: border-box;
      }
    }
  }
}

.btn {
  background-color: lightgray;
  z-index: 9999;
  position: fixed;
  bottom: 1px;
  width: calc(100vw);
  margin: 0 -2rem;
  display: flex;
  justify-content: flex-end;
  /* 靠右对齐 */
  align-items: center;
}
</style>
<style lang="less"></style>
